import { tv } from 'tailwind-variants'
import { Paragraph as P } from '_/ui/paragraph'

const infoName = tv({
	base: 'text-sm text-gray-500 font-normal',
})

export const InfoName = ({ className, children }: { className?: string; children: React.ReactNode }) => (
	<P className={infoName({ class: className })}>{children}</P>
)

const info = tv({
	base: 'text-base text-gray-700 font-bold flex gap-2 mt-1.5',
})

export const Info = ({ className, children }: { className?: string; children: React.ReactNode }) => (
	<P className={info({ class: className })}>{children}</P>
)
